import { Component } from 'react'
import { OnsetAge, OnsetDateTime, OnsetPeriod, OnsetRange, OnsetString, Code, CodeableConcept } from '../helpers'
import { GiPollenDust } from 'react-icons/gi'

import './resource.css'

class AllergyIntolerance extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isJson: false,
            css: false
        }
    }

    handleJson() {
        this.setState({ css: !this.state.css })
        setTimeout(() => this.setState({ isJson: !this.state.isJson }), 300)
    }

    handleSelect(id) {
        if (this.props.onSelect) this.props.onSelect(id)
    }

    render() {
        return <div className={`Flip-Container`} onClick={() => this.handleJson()}><div className={`Res-Container Res-Allergy${this.state.css ? ' Flip' : ''}`}>
            {this.state.isJson ? <div className='Res-Json'><pre>{JSON.stringify(this.props.resource, undefined, 2)}</pre></div> :
                <div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.clinicalStatus && 'Status'}</div>
                            <div className='Res-Title'>{this.props.resource.clinicalStatus && CodeableConcept(this.props.resource.clinicalStatus)}</div>
                        </div>
                        <div className='Res-Icon-Big'><GiPollenDust /></div>
                        <div>
                            <div style={{ textAlign: 'right' }} className='Res-Detail Res-Content-Rev'>{this.props.resource.verificationStatus && 'Status'}</div>
                            <div className='Res-Title'>{this.props.resource.verificationStatus && CodeableConcept(this.props.resource.verificationStatus)}</div>
                        </div>
                    </div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.type && 'Type'}</div>
                            <div className='Res-Title'>{this.props.resource.type && Code(this.props.resource.type)}</div>
                        </div>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.category && 'Category'}</div>
                            <div className='Res-Title'>{this.props.resource.category && Code(this.props.resource.category)}</div>
                        </div>
                    </div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.criticality && 'Criticality'}</div>
                            <div className='Res-Title'>{this.props.resource.criticality && Code(this.props.resource.criticality)}</div>
                        </div>
                        <div>
                            <div style={{ textAlign: 'right' }} className='Res-Detail Res-Content-Rev'>{this.props.resource.code && 'Allergy'}</div>
                            <div style={{ textAlign: 'right' }} className='Res-Title'>{this.props.resource.code && CodeableConcept(this.props.resource.code)}</div>
                        </div>
                    </div>
                    {this.props.resource.onsetAge && <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>Onset</div>
                        <div className='Res-Title'>{OnsetAge(this.props.resource.onsetAge)}</div>
                    </div>}
                    {this.props.resource.onsetDateTime && <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>Onset</div>
                        <div className='Res-Title'>{OnsetDateTime(this.props.resource.onsetDateTime)}</div>
                    </div>}
                    {this.props.resource.onsetPeriod && <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>Onset</div>
                        <div className='Res-Title'>{OnsetPeriod(this.props.resource.onsetPeriod)}</div>
                    </div>}
                    {this.props.resource.onsetRange && <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>Onset</div>
                        <div className='Res-Title'>{OnsetRange(this.props.resource.onsetRange)}</div>
                    </div>}
                    {this.props.resource.onsetString && <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>Onset</div>
                        <div className='Res-Title'>{OnsetString(this.props.resource.onsetString)}</div>
                    </div>}
                </div>
            }
        </div></div>
    }
}

export default AllergyIntolerance